export * from "./crud-box.module";
export * from "./crud-box.component";



// WEBPACK FOOTER //
// ./libs/atenea-cms/src/crud-box/index.ts